import React from 'react';

const HeatmapTracking = ({ 
  elementName, 
  trackClicks = true, 
  trackHovers = true, 
  children 
}) => {
  return (
    <div>
      {children}
    </div>
  );
};

export default HeatmapTracking;